// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loadingDots{display:inline}@keyframes fadeIn{from{opacity:0}}.loadingDots .dot{display:inline;-webkit-animation:fadeIn .7s infinite alternate;animation:fadeIn .7s infinite alternate}.loadingDots #dot2{-webkit-animation-delay:.1s;animation-delay:.1s}.loadingDots #dot3{-webkit-animation-delay:.2s;animation-delay:.2s}", ""]);
// Exports
module.exports = exports;
